// This file was automatically generated from appchart.visitNote.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.visitNote');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appchart.confidentialCheckbox');
goog.require('el8.template.ptdata.model.attachment');
goog.require('el8.template.ptdata.model.note');
goog.require('el8.template.util.format');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.formHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="urgent fl"></div><div class="visitNoteHeaderText"><div class="visit-date-clickable headerEditableText "><a id="visit-date">', (soy.$$escapeHtml(opt_data.visitDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.visitDate)) : ''), '</a><span class="el8EditIconNoHover"></span></div>', (! opt_data.isAmend) ? '<span class="leftIndent">NEW</span>' : '<span class="leftIndent">AMEND</span>', '<span class="leftIndent"><select name="visitNoteType" class="w28 normalFont">');
  el8.template.appchart.visitNote.noteTypeOptions(opt_data, output);
  output.append('</select></span><span class="leftIndent"><select name="physicianId" class="w28 normalFont">');
  var pList6077 = opt_data.physicians;
  var pListLen6077 = pList6077.length;
  for (var pIndex6077 = 0; pIndex6077 < pListLen6077; pIndex6077++) {
    var pData6077 = pList6077[pIndex6077];
    output.append('<option value="', soy.$$escapeHtml(pData6077.staffId), '">', soy.$$escapeHtml(pData6077.name), '</option>');
  }
  output.append('</select></span></div><span id="thirdpane-view-mode-trigger" class="threePaneButton"></span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.noteTypeOptions = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var typeList6086 = opt_data.noteTypes;
  var typeListLen6086 = typeList6086.length;
  for (var typeIndex6086 = 0; typeIndex6086 < typeListLen6086; typeIndex6086++) {
    var typeData6086 = typeList6086[typeIndex6086];
    output.append('<option value="', soy.$$escapeHtml(typeData6086.id), '" ', (opt_data.currentlySelected && opt_data.currentlySelected == typeData6086.id) ? 'selected' : '', '>', soy.$$escapeHtml(typeData6086.name), '</option>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.formToolbar = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="timerSection"><div class="el8TableRow"><div id="visit-timer-with-patient-label" class="el8FieldSection wauto padr30 el8TimerLeft el8TableCell"><div class="el8InlineBlock"><a class="el8StandardFontSize el8FormLinkWithBorder" id="visit-note-view-templates-trigger">Visit&nbsp;Note&nbsp;Templates</a></div></div><div id="visit-timers" class="el8FieldSection wauto el8Timer el8TableCell"><div id="visit-timer-with-patient" class="el8InlineBlock padl5 padr5"><span class="el8AppText el8RightIndent">Time with patient:</span><span class="timerWrap"><input type="text" name="timer" value="00:00:00" size=7></span><span class="timer-buttons"><a tabindex="-1" class="pause-trigger el8SmallTextLink">Start</a> <a tabindex="-1" class="stop-trigger el8SmallTextLink">Stop</a> <span class="switch-trigger"><a tabindex="-1" class="el8SmallTextLink">Switch&nbsp;Timer</a></span></span></div><div id="visit-timer-documenting" class="el8InlineBlock padl5 padr5"><span class="el8AppText el8RightIndent">Time documenting:</span><span class="timerWrap"><input type="text" name="timer" value="00:00:00" size=7></span><span class="timer-buttons"><a tabindex="-1" class="pause-trigger el8SmallTextLink">Start</a> <a tabindex="-1" class="stop-trigger el8SmallTextLink">Stop</a></span></div></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.bpInput = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="bp-input el8FieldSection" _bpindex="', soy.$$escapeHtml(opt_data.index), '"><label class="el8label">BP:</label><div class="el8FieldShortLabelPadding"><div class="bpWrap el8TextareaWrap"><input type="number" placeholder="Sys" class="vitalsSysInput w100" size="1" name="bpS_', soy.$$escapeHtml(opt_data.index), '" value="" autocomplete="off" /><span class="frame">/</span><input type="number" placeholder="Dias" class="vitalsDiasInput w100" size="1" name="bpD_', soy.$$escapeHtml(opt_data.index), '" value="" autocomplete="off" /></div><div class="bpNoteContainer el8TextareaWrap"><textarea class="w100" name="bpNote_', soy.$$escapeHtml(opt_data.index), '" value="" autocomplete="off"></textarea></div></div><a _bpindex="', soy.$$escapeHtml(opt_data.index), '" class="remove-bp-trigger removeBPTrigger" style="display:none;display:hidden;"></a><a _bpindex="', soy.$$escapeHtml(opt_data.index), '" class="add-bp-trigger addBPTrigger"></a></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.fieldVitals = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isVitalsHidden) ? '<div class="actionFieldNoteButton"><a tabindex="-1" class="vitals-show-trigger el8FormLink">+ Add Vitals</a></div>' : '', '<div class="vitals-container"', (opt_data.isVitalsHidden) ? ' style="display:none; display:hidden"' : '', '><p class="fieldTitle">Vitals:</p><span class="bp-section">');
  el8.template.appchart.visitNote.bpInput({index: 0}, output);
  output.append('</span><div class="el8FieldSectionOverflow"><div class="w49 fl"><div class="el8FieldSection"><label class="el8label">HR:</label><div class="el8FieldShortLabelPadding"><div class="vitalsWithNoteWrap el8TextareaWrap"><input type="text" class="w100" size="2" name="hr" autocomplete="off" /></div><div class="vitals-wrapper vitalsNoteContainer el8Wrap"><a tabindex="-1" class="vitals-note-show-trigger el8StandardLink" data-type="hr">+ Note</a></div><div class="hr-note-section vitalsNoteContainer el8TextareaWrap" style="display:none; display:hidden"><textarea class="w100" name="hrNote" autocomplete="off"></textarea></div></div></div></div><div class="w49 fl"><div class="el8FieldSection"><label class="el8label" style="width: 38px">Temp:</label><div class="el8FieldShortLabelPadding"><div class="vitalsWithNoteWrap el8TextareaWrap"><input type="text" class="w100" size="2" name="temperature" autocomplete="off" /></div><div class="vitals-wrapper vitalsNoteContainer el8Wrap"><a tabindex="-1" class="vitals-note-show-trigger el8StandardLink" data-type="temp">+ Note</a></div><div class="temp-note-section vitalsNoteContainer el8TextareaWrap" style="display:none; display:hidden"><textarea class="w100" name="tempNote" autocomplete="off"></textarea></div></div></div></div></div><div class="el8FieldSectionOverflow"><div class="w49 fl"><div class="el8FieldSection"><label class="el8label">RR:</label><div class="el8FieldShortLabelPadding"><div class="vitalsWithNoteWrap el8TextareaWrap"><input type="text" class="w100" size="2" name="rr" autocomplete="off" /></div><div class="vitals-wrapper vitalsNoteContainer el8Wrap"><a tabindex="-1" class="vitals-note-show-trigger el8StandardLink" data-type="rr">+ Note</a></div><div class="rr-note-section vitalsNoteContainer el8TextareaWrap" style="display:none; display:hidden"><textarea class="w100" name="rrNote" autocomplete="off"></textarea></div></div></div></div><div class="w49 fl"><div class="el8FieldSection"><label class="el8label">Ht:</label><div class="el8FieldShortLabelPadding"><div class="vitalsWithNoteWrap el8TextareaWrap"><input type="text" class="w100" size="2" name="height" autocomplete="off" /></div><div class="processedInfo" style="display:none">(<span class="height-processed-val frame"></span>in)</div><div class="vitals-wrapper vitalsNoteContainer el8Wrap"><a tabindex="-1" class="vitals-note-show-trigger el8StandardLink" data-type="ht">+ Note</a></div><div class="ht-note-section vitalsNoteContainer el8TextareaWrap" style="display:none; display:hidden"><textarea class="w100" name="htNote" autocomplete="off"></textarea></div></div></div></div></div><div class="el8FieldSectionOverflow"><div class="w49 fl"><div class="el8FieldSection"><label class="el8label">Wt:</label><div class="el8FieldShortLabelPadding"><div class="vitalsWithNoteWrap el8TextareaWrap"><input type="text" class="w100" size="2" name="weight" autocomplete="off" /></div><div class="vitals-wrapper vitalsNoteContainer el8Wrap"><a tabindex="-1" class="vitals-note-show-trigger el8StandardLink" data-type="wt">+ Note</a></div><div class="wt-note-section vitalsNoteContainer el8TextareaWrap" style="display:none; display:hidden"><textarea class="w100" name="wtNote" autocomplete="off"></textarea></div><div class="previousVital"><span class="previous-weight"></span></div><!-- Hidden for design purposes, but displayed for BMI computing --><div class="processedInfo" style="display:none">(<span class="weight-processed-val frame"></span>lbs)</div></div></div></div><div class="w49 fl"><div class="el8FieldSection"><label class="el8label">BMI:</label><div class="el8FieldShortLabelPadding"><div class="bmiWrap el8TextareaWrap"><div class="bmi el8StandardFontSize"></div></div><div class="previousVital"><span class="previous-bmi"></span></div></div></div></div></div><div class="el8FieldSectionOverflow fieldNoteSection"><div class="w49 fl"><div class="el8FieldSection"><label class="el8label">O<span class="subscript">2</span>:</label><div class="el8FieldShortLabelPadding"><div class="vitalsWithNoteWrap el8TextareaWrap"><input type="text" class="w100" size="3" name="oxygen" autocomplete="off" /></div><div class="vitals-wrapper vitalsNoteContainer el8Wrap"><a tabindex="-1" class="vitals-note-show-trigger el8StandardLink" data-type="oxygen">+ Note</a></div><div class="oxygen-note-section vitalsNoteContainer el8TextareaWrap" style="display:none; display:hidden"><textarea class="w100" name="oxygenNote" autocomplete="off"></textarea></div></div></div></div><div class="w49 fl"><div class="el8FieldSection"><label class="el8label">HC:</label><div class="el8FieldShortLabelPadding"><div class="vitalsWithNoteWrap el8TextareaWrap"><input type="text" class="w100" size="2" name="hc" autocomplete="off" /></div><div class="vitals-wrapper vitalsNoteContainer el8Wrap"><a tabindex="-1" class="vitals-note-show-trigger el8StandardLink" data-type="hc">+ Note</a></div><div class="hc-note-section vitalsNoteContainer el8TextareaWrap" style="display:none; display:hidden"><textarea class="w100" name="hcNote" autocomplete="off"></textarea></div></div></div></div></div><div class="el8FieldSectionOverflow fieldNoteSection"><div class="w49 fl"><div class="el8FieldSection"><label class="el8label">Pain:</label><div class="el8FieldShortLabelPadding"><div class="vitalsWithNoteWrap el8TextareaWrap"><input type="text" class="w100" size="3" name="pain" autocomplete="off" /></div><div class="vitals-wrapper vitalsNoteContainer el8Wrap"><a tabindex="-1" class="vitals-note-show-trigger el8StandardLink" data-type="pain">+ Note</a></div><div class="pain-note-section vitalsNoteContainer el8TextareaWrap" style="display:none; display:hidden"><textarea class="w100" name="painNote" autocomplete="off"></textarea></div></div></div></div></div>');
  if (! opt_data.isVisitNoteTemplate) {
    if (opt_data.additionalVitals && ! opt_data.suppressCustomObservations) {
      el8.template.appchart.visitNote._additionalVitalFields(null, output);
    }
    output.append((opt_data.showButtons) ? '<div class="el8FieldShortLabelPadding fieldNoteSection"><ul class="el8ButtonContainer mt5"><li class="el8ButtonItem"><a tabindex="-1" class="vitals-trends-trigger el8FormLink">Vital Trends</a></li>' + ((opt_data.patientAge < el8.util.consts.PEDIATRIC_AGE_LIMIT) ? '<li class=""><a tabindex="-1" class="growth-chart-trigger el8FormLink">Growth Charts</a></li>' : '') + '</ul></div>' : '');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote._additionalVitalFields = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSectionOverflow fieldNoteSection">');
  el8.template.appchart.visitNote._customVitalField({label: '% BF', name: 'bodyfat'}, output);
  el8.template.appchart.visitNote._customVitalField({label: 'Δ DLM', name: 'dlm', customWidth: '43px'}, output);
  output.append('</div><div class="el8FieldSectionOverflow fieldNoteSection">');
  el8.template.appchart.visitNote._customVitalField({label: 'Δ BFM', name: 'bfm', customWidth: '43px'}, output);
  el8.template.appchart.visitNote._customVitalField({label: 'WC', name: 'wc'}, output);
  output.append('</div><div class="el8FieldSectionOverflow fieldNoteSection">');
  el8.template.appchart.visitNote._customVitalField({label: 'Ketone', name: 'ketone'}, output);
  el8.template.appchart.visitNote._customVitalField({label: 'FiO2', name: 'fio2'}, output);
  output.append('</div><div class="el8FieldSectionOverflow fieldNoteSection">');
  el8.template.appchart.visitNote._customVitalField({label: 'SMM', name: 'smm'}, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote._customVitalField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="w49 fl"><div class="el8FieldSection"><label class="el8label" ', (opt_data.customWidth) ? 'style="width: ' + soy.$$escapeHtml(opt_data.customWidth) + '"' : '', '>', soy.$$escapeHtml(opt_data.label), ':</label><div class="el8FieldShortLabelPadding"><div class="vitalsWithNoteWrap el8TextareaWrap"><input type="text" class="w100" name="', soy.$$escapeHtml(opt_data.name), '" autocomplete="off" /></div><div class="vitals-wrapper vitalsNoteContainer el8Wrap"><a tabindex="-1" class="vitals-note-show-trigger el8StandardLink" data-type="', soy.$$escapeHtml(opt_data.name), '">+ Note</a></div><div class="', soy.$$escapeHtml(opt_data.name), '-note-section vitalsNoteContainer el8TextareaWrap" style="display:none; display:hidden"><textarea class="w100" name="', soy.$$escapeHtml(opt_data.name), 'Note" autocomplete="off"></textarea></div><div class="previousVital"><span class="previous-', soy.$$escapeHtml(opt_data.name), '"></span></div></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.linksPlan = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldNoteButton">', (! el8Globals.READ_ONLY) ? '<ul class="el8ButtonContainer"><li class=""><a tabindex="-1" class="referral_order_trigger el8FormLink" ampsource="VisitNote">Referral</a></li><li class=""><a tabindex="-1" _type="prescription" class="meds_order_trigger el8FormLink" data-amplitude-source="visit note">Rx/OTC/CS</a></li><li class=""><a tabindex="-1" class="samples_med_order_trigger el8FormLink" data-amplitude-source="visit note">Samples</a></li><li class=""><a tabindex="-1" class="lab_order_trigger el8FormLink" ampsource="Visit Note - Plan">Lab</a></li><li class=""><a tabindex="-1" class="imaging_order_trigger el8FormLink">Imaging</a></li><li class=""><a tabindex="-1" class="cardiac_order_trigger el8FormLink">Cardiac</a></li><li class=""><a tabindex="-1" class="pulmonary_order_trigger el8FormLink">Pulmonary</a></li><li class=""><!-- Sleep to Generic order UI reskin -->' + ((el8Globals.FEATURES.GenericOrder) ? '<a tabindex="-1" class="sleep_order_trigger el8FormLink">Order</a>' : '<a tabindex="-1" class="sleep_order_trigger el8FormLink">Sleep</a>') + '</li><li class=""><a tabindex="-1" class="add-immunization-trigger el8FormLink" data-amplitude-source="visit note">Vaccination</a></li><li class=""><a tabindex="-1" class="educational-handouts-trigger el8FormLink">Handouts</a></li></ul>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.linksTest = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldNoteButton">', (! el8Globals.READ_ONLY) ? '<ul class="el8ButtonContainer"><li class=""><a tabindex="-1" class="lab_order_trigger el8FormLink" ampsource="Visit Note - Test">Lab</a></li><li class=""><a tabindex="-1" class="imaging_order_trigger el8FormLink">Imaging</a></li><li class=""><a tabindex="-1" class="cardiac_order_trigger el8FormLink">Cardiac</a></li><li class=""><a tabindex="-1" class="pulmonary_order_trigger el8FormLink">Pulmonary</a></li><li class=""><!-- Sleep to Generic order UI reskin -->' + ((el8Globals.FEATURES.GenericOrder) ? '<a tabindex="-1" class="sleep_order_trigger el8FormLink">Order</a>' : '<a tabindex="-1" class="sleep_order_trigger el8FormLink">Sleep</a>') + '</li></ul>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.linksTx = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldNoteButton">', (! el8Globals.READ_ONLY) ? '<ul class="el8ButtonContainer"><li class=""><a tabindex="-1" class="referral_order_trigger el8FormLink" ampsource="VisitNote">Referral</a></li><li class=""><a tabindex="-1" _type="prescription" class="meds_order_trigger el8FormLink" data-amplitude-source="visit note">Rx/OTC/CS</a></li><li class=""><a tabindex="-1" class="samples_med_order_trigger el8FormLink" data-amplitude-source="visit note">Samples</a></li><li class=""><a tabindex="-1" class="add-immunization-trigger el8FormLink" data-amplitude-source="visit note">Vaccination</a></li><li class=""><a tabindex="-1" class="educational-handouts-trigger el8FormLink">Handouts</a></li></ul>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.linksHabits = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldNoteButton"><a tabindex="-1" class="visit-note-ref-history-button el8FormLink" _type="habits">Import Habits</a></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.linksSocial = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldNoteButton"><a tabindex="-1" class="visit-note-ref-history-button el8FormLink" _type="social">Import SH</a></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.linksFamily = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldNoteButton"><a tabindex="-1" class="visit-note-ref-history-button el8FormLink" _type="family">Import FH</a></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.linksSurgical = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldNoteButton"><a tabindex="-1" class="visit-note-ref-history-button el8FormLink" _type="surgical">Import PSH</a></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.linksAllergies = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldNoteButton"><a tabindex="-1" id="visit-note-ref-allergies-button" class="el8FormLink">Import Allergies</a></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.linksPast = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldNoteButton"><ul class="el8ButtonContainer"><li class=""><a tabindex="-1" id="visit-note-ref-problems-button" class="el8FormLink">Import Active Problems</a></li><li class=""><a tabindex="-1" class="visit-note-ref-history-button el8FormLink" _type="past">Import PMH</a></li></ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.linksProblem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldNoteButton"><a tabindex="-1" id="visit-note-ref-problems-labs-button" class="el8FormLink">Import Labs & Associated Problems</a></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.linksMed = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldNoteButton"><a tabindex="-1" id="visit-note-ref-meds-button" class="el8FormLink">Import Current Meds</a></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.linksData = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldNoteButton"><a tabindex="-1" class="enter-poc-result-trigger el8FormLink">Enter Point-of-Care Lab Result</a></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.practiceInternalData = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="visit-note-internal-section">');
  if (el8Globals.FEATURES.MUReports) {
    el8.template.appchart.visitNote.muSection(null, output);
  }
  el8.template.appchart.visitNote.confidentialitySection(null, output);
  output.append('<fieldset class="el8FieldSectionOverflow el8VisitNoteBillingSection"><div class="billing-summary w100"></div></fieldset></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.billSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.bill) {
    output.append('<p class="el8Bold el8AppColor mb5">Billing Information <span class="el8NormalText ml5"><a class="bill-dialog-trigger">Edit Billing</a></span>', (opt_data.isInvoicingEnabled) ? '<button type="button" class="el8button fr el8IconButton print-invoice-trigger"><span class="el8PrintIcon"></span>Print Invoice<span class="el8ButtonDropdownArrow"></span></button>' : '', (opt_data.bill.isEarlyBill && opt_data.isVisitNoteSendBillToPmsEnabled) ? '<button type="button" class="el8button fr mr5 send-bill-early-trigger" disabled="disabled">Send Bill to PMS</span></button>' : (opt_data.bill.billingStatus == el8.util.consts.BILLING_STATUS.Unbilled && opt_data.isPMSIntegrated) ? ((opt_data.isDeferredBillsEnabled && ! opt_data.bill.isDeferredBill) ? '<button type="button" class="el8button fr mr5 queue-bill-trigger">Send to Queue</span></button>' : '') + ((opt_data.isVisitNoteSendBillToPmsEnabled) ? '<button type="button" class="el8button fr mr5 send-bill-early-trigger">Send to PMS</span></button>' : '') : '', '</p>');
    var cptObjList6260 = opt_data.bill.cpts;
    var cptObjListLen6260 = cptObjList6260.length;
    for (var cptObjIndex6260 = 0; cptObjIndex6260 < cptObjListLen6260; cptObjIndex6260++) {
      var cptObjData6260 = cptObjList6260[cptObjIndex6260];
      output.append('<p><span class="el8999 padr5">', soy.$$escapeHtml(cptObjIndex6260 + 1), '</span>');
      el8.template.ptdata.model.note.billCptSummary(soy.$$augmentData(cptObjData6260, {isShowDualCoding: opt_data.bill.isShowDualCoding}), output);
      output.append('</p>');
    }
    output.append('<div class="el8Spacer5"></div>', (opt_data.bill.refNumber || opt_data.bill.billingDate || opt_data.bill.billingStatus == el8.util.consts.BILLING_STATUS.ResolvedError || opt_data.bill.billingStatus == el8.util.consts.BILLING_STATUS.UnresolvedError || opt_data.bill.isEarlyBill) ? '<div class="el8BillingHeaderItem"><label class="el8label el8BillingHeaderLabel">Billing Status</label>' + ((opt_data.bill.refNumber || opt_data.bill.billingDate) ? '<p>' + ((opt_data.bill.billingDate) ? 'Billed on ' + (soy.$$escapeHtml(opt_data.bill.billingDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.bill.billingDate)) : '') : 'Date unknown') + ' ' + ((opt_data.bill.refNumber) ? '(#' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.bill.refNumber)) : soy.$$escapeHtml(opt_data.bill.refNumber)) + ')' : '') + '</p>' : (opt_data.bill.billingStatus == el8.util.consts.BILLING_STATUS.ResolvedError) ? '<p class="bill-error-text">Acknowledged Error (Bill will not be submitted automatically)</p>' : (opt_data.bill.billingError) ? '<p class="bill-error-text el8AlertText">Error: ' + soy.$$escapeHtml(opt_data.bill.billingError) + '</p>' : (opt_data.bill.isEarlyBill) ? '<p>Pending submission to billing system</p>' : '') + '</div>' : '', (opt_data.bill.serviceLocation) ? '<div class="el8BillingHeaderItem"><label class="el8label el8BillingHeaderLabel">Service Location</label><p>' + soy.$$escapeHtml(opt_data.bill.serviceLocation) + '</p></div>' : '', (opt_data.bill.referringProvider) ? '<div class="el8BillingHeaderItem"><label class="el8label el8BillingHeaderLabel">Referring Provider</label><p class="el8Preserve">' + soy.$$escapeHtml(opt_data.bill.referringProvider) + '</p></div>' : '');
    if (opt_data.billNotesWordsArray.length) {
      output.append('<div class="el8BillingHeaderItem"><label class="el8label el8BillingHeaderLabel">Additional Billing Notes</label><p class="el8Preserve">');
      var wordObjList6312 = opt_data.billNotesWordsArray;
      var wordObjListLen6312 = wordObjList6312.length;
      for (var wordObjIndex6312 = 0; wordObjIndex6312 < wordObjListLen6312; wordObjIndex6312++) {
        var wordObjData6312 = wordObjList6312[wordObjIndex6312];
        output.append((! (wordObjIndex6312 == 0)) ? ' ' : '', (wordObjData6312.isLink) ? '<a target="_blank" rel="noopener noreferrer" href="' + soy.$$escapeHtml(wordObjData6312.word) + '">' + soy.$$escapeHtml(wordObjData6312.word) + '</a>' : soy.$$escapeHtml(wordObjData6312.word));
      }
      output.append('</p></div>');
    }
    output.append((opt_data.bill.copayCollected && opt_data.bill.copayCollected.amount) ? '<div class="el8BillingHeaderItem"><label class="el8label el8BillingHeaderLabel">Patient Payment</label><p class="el8Preserve">' + (soy.$$escapeHtml(opt_data.bill.copayCollected.amount)? el8.util.string.formatMoney(soy.$$escapeHtml(opt_data.bill.copayCollected.amount)) : '') + '</p></div>' : '', (opt_data.isDeferredBillsEnabled && ! opt_data.bill.isEarlyBill) ? (opt_data.bill.isDeferredBill) ? '<p class="el8BillingQueuedNote">This bill is queued</p>' : '<p class="el8BillingQueuedNote">This bill will be automatically queued after sign-off</p>' : '');
  } else if (! el8Globals.READ_ONLY) {
    output.append('<button type="button" class="el8button bill-dialog-trigger el8BigButton w60 ml20percent">+ Add Billing Information</button>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.muSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8VisitNoteMUSection"><p class="el8Bold padb15">Questions for Promoting Interoperability Compliance</p><div class="el8FieldSectionOverflow padb10"><p class="w30 padt2" style="float: left;"><span class="el8MUTag fl mr5">MIPS</span>Transition of care?</p><ul class="el8ButtonContainer" style="text-align: right;"><li class="el8ButtonItem mr15"><label class="el8label el8Radio"><input class="mtneg4 transition-type" type="checkbox" name="receivingTransition" value="receiving" /><a class="el8LeftIndent">Received from other setting or provider</a></label></li><li class="el8ButtonItem mr15"><label class="el8label el8Radio"><input class="mtneg4 transition-type" type="checkbox" name="referringTransition" value="referring" /><a class="el8LeftIndent">Referring to other setting or provider</a></label></li></ul></div><div class="el8FieldSectionOverflow"><div class="clearfix"><div class="el8ToggleContainer el8ThirdToggle fr"><input type="radio" name="currentMedsDocumented" value="TRUE" id="medDocYes" class="el8Toggle el8ToggleTrue"><label for="medDocYes" class="el8label el8ToggleLabel el8ToggleLabelOn">Yes</label><input type="radio" name="currentMedsDocumented" value="FALSE" id="medDocNo" class="el8Toggle el8ToggleFalse"><label for="medDocNo" class="el8label el8ToggleLabel el8ToggleLabelOff">No</label><input type="radio" name="currentMedsDocumented" value="NA" id="medDocNA" checked="checked" class="el8Toggle el8ToggleFalse"><label for="medDocNA" class="el8label el8ToggleLabel el8ToggleLabelThird">N/A</label><span class="el8ToggleSelection"></span></div><p class="padt6">Current Medications Patient Is Taking Documented in Chart?</p></div></div><div id="mu-toc-receiving" class="mu-toc el8FieldSectionOverflow mt5" style="display:none;"><div class="clearfix"><div class="el8ToggleContainer fr mr50"><input type="radio" name="medsReconciled" value="1" id="medsReconciledYes" class="el8Toggle el8ToggleTrue"><label for="medsReconciledYes" class="el8label el8ToggleLabel el8ToggleLabelOn">Yes</label><input type="radio" name="medsReconciled" value="0" id="medsReconciledNo" class="el8Toggle el8ToggleFalse"><label for="medsReconciledNo" class="el8label el8ToggleLabel el8ToggleLabelOff">No</label><span class="el8ToggleSelection"></span></div><p class="padt6"><span class="el8MUTag fl mr5">MIPS</span>Were medications, allergies, and problems reconciled during encounter?</p></div></div><div id="mu-toc-referring" class="mu-toc el8FieldSectionOverflow mt5" style="display:none;"><div class="clearfix"><div class="el8ToggleContainer fr mr50"><input type="radio" name="summaryOfCareProvided" value="1" id="summaryOfCareProvidedYes" class="el8Toggle el8ToggleTrue"><label for="summaryOfCareProvidedYes" class="el8label el8ToggleLabel el8ToggleLabelOn">Yes</label><input type="radio" name="summaryOfCareProvided" value="0" id="summaryOfCareProvidedNo" class="el8Toggle el8ToggleFalse"><label for="summaryOfCareProvidedNo" class="el8label el8ToggleLabel el8ToggleLabelOff">No</label><span class="el8ToggleSelection"></span></div><p class="padt6"><span class="el8MUTag fl mr5">MIPS</span>Was a summary of care record provided?</p></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.confidentialitySection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8VisitNoteBillingSection confidentiality-section">');
  el8.template.appchart.confidentialCheckbox.content(null, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.muTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.direction == 'referring') ? 'Referring a patient to a setting of care (hospital, ambulatory primary or specialty care practice, long-term care, home health, rehab facility)' : (opt_data.direction == 'receiving') ? 'Receiving a patient from a setting of care (hospital, ambulatory primary or specialty care practice, long-term care, home health, rehab facility)' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.formContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="note-new-visit-content-scrollable"><div id="note-alert-feed-container" class="cardColumn alertContainer" style="display:none; display:hidden;"></div><form id="note-new-visit-form"><!-- This is where we stick in templates from data.visitNoteFormTemplates --></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.imagesAndAttachments = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.images.length || opt_data.attachments.length) {
    output.append('<p class="fieldTitle">Attachments:</p>');
    if (opt_data.images.length) {
      output.append('<div class="visit-images-loading visitNoteImagesInfo">There are ', soy.$$escapeHtml(opt_data.images.length), ' images being loaded in this note...</div><ol>');
      var imageList6365 = opt_data.images;
      var imageListLen6365 = imageList6365.length;
      for (var imageIndex6365 = 0; imageIndex6365 < imageListLen6365; imageIndex6365++) {
        var imageData6365 = imageList6365[imageIndex6365];
        output.append('<li><div class="images_', soy.$$escapeHtml(imageIndex6365), ' el8VNImage">', (! opt_data.isAmendment) ? '<div class="el8VNImageActions"><button type="button" tabindex="-1" class="el8button remove-visit-attachment el8ShortButton el8VNRemoveImageButton" data-id="' + soy.$$escapeHtml(opt_data.imageIds[imageIndex6365]) + '"><span class="el8VNRemoveImageText">Remove</span><span class="el8VNRemoveImageIcon">&times;</span></button></div>' : '', '<div data-src="', soy.$$escapeHtml(imageData6365), '" class="image-item" data-id="', soy.$$escapeHtml(opt_data.id), '"></div></div></li>');
      }
      output.append('</ol>');
    }
    if (opt_data.attachments.length) {
      output.append('<ol>');
      var itemList6384 = opt_data.attachments;
      var itemListLen6384 = itemList6384.length;
      for (var itemIndex6384 = 0; itemIndex6384 < itemListLen6384; itemIndex6384++) {
        var itemData6384 = itemList6384[itemIndex6384];
        if (itemData6384.type != 'imported_file') {
          output.append('<li class="el8BulletText"><a target="_blank" rel="noopener" href="', soy.$$escapeHtml(itemData6384.downloadUrl), '" tabindex="-1">');
          el8.template.ptdata.model.attachment.summary(itemData6384, output);
          output.append('</a>', (! opt_data.isAmendment) ? '<a class="remove-visit-attachment el8RemoveAttachmentButton" data-id="' + soy.$$escapeHtml(itemData6384.printableId) + '">&times;</a>' : '', '</li>');
        }
      }
      output.append('</ol>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.form = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="thirdPaneHeaderContainer">');
  el8.template.appchart.visitNote.formHeader(opt_data, output);
  output.append('</div><div id="note-timers-container" class="el8Background">');
  el8.template.appchart.visitNote.formToolbar(opt_data, output);
  output.append('</div><div id="note-new-visit-content" class="dialogContainer el8Background w100">');
  el8.template.appchart.visitNote.formContent(opt_data, output);
  output.append('</div><div id="note-new-visit-buttons" class="ui-dialog-buttonpane"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.templateform = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="visit-note-template-content" class="dialogContainer el8Background w100"><div id="visit-note-template-warnings-container"></div><form id="visit-note-template-form" class="el8VisitNoteTemplateBackground">');
  el8.template.appchart.visitNote.templateformNameField(null, output);
  output.append('<div id="visit-note-template-form-main-section"><!-- This is where we stick in templates from data.visitNoteFormTemplates --></div>');
  el8.template.appchart.visitNote.templateformBillingSection(null, output);
  el8.template.appchart.visitNote.templateformBillingExtraInfo(null, output);
  output.append('</form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.templateReadOnlyWarning = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="visit-note-readonly-callout-container" style="background: #f4f4f4;padding: 10px"><div id="visit-note-readonly-callout" style="display:flex;align-items: center;background: #FFF8D6;border-radius:3px;padding:10px 12px 9px;"><div style="margin-right: 10px;"><span class="VdsIcon__wrap" style="--local-icon-size:1.5rem;"><svg width="24" height="24" fill="none" class="VdsIcon__svg"><path d="M12 9a1.2 1.2 0 110-2.4A1.2 1.2 0 0112 9zm0 8a1 1 0 01-1-1v-5a1 1 0 112 0v5a1 1 0 01-1 1z" fill="#000"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0z" fill="#000"></path></svg></span></div><div><span style="font: var(--vds-text-body-md-strong)">Only admins can add, edit, or delete templates.</span></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.templateformNameField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection el8VisitNoteTemplateHead"><label class="el8label el8FieldExtraLong el8LgText el8NormalWeight mt10">Template Name:</label><div class="el8FieldExtraLongLabelPadding el8TextareaWrap"><input type="text" class="el8LgText w100" name="templateName" /></div><div class="mv10 mt15 mh20"><p class="el8AppColor">Note: This template can be applied to any type of visit note including all Complete H&amp;P Notes, Simple Note, Pre-Op Note, and SOAP Note.</p></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.templateformBillingSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="billing-main-form el8VisitNoteTemplateBillingBackground el8BillingTop"><div class="section-title noteSectionTitle">Billing Information</div><div class="el8BillingFormLabels mt10"><div class="el8StrongMiniHeading el8AlignCenter el8InlineBlock" style="width:70px">CPT®</div><div class="el8StrongMiniHeading el8AlignCenter el8InlineBlock" style="width:130px">Modifier</div></div><ol class="billing-entry-holder el8BillingItem"></ol><button type="button" tabindex="-1" class="el8button add-billing-entry mt10">+ Add another billing item</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.textlistItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="textlist-item el8BulletText el8ItemHover" data-id="', soy.$$escapeHtml(opt_data.id), '">', (! opt_data.isEdit) ? '<div class="el8RemoveButtonItemPosition"><a class="textlist-item-remove-trigger el8RemoveItemButton" data-id="' + soy.$$escapeHtml(opt_data.id) + '"></a></div>' : '', '<a class="details-trigger" data-id="', soy.$$escapeHtml(opt_data.docId), '">');
  if (opt_data.text) {
    output.append(opt_data.text);
  } else if (opt_data.summary) {
    el8.template.util.format.apply({text: opt_data.summary, formatting: opt_data.summaryFormatting}, output);
  }
  output.append('</a></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.detailChecklistForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<fieldset class="checklist">');
  var choiceList6444 = opt_data.choices;
  var choiceListLen6444 = choiceList6444.length;
  for (var choiceIndex6444 = 0; choiceIndex6444 < choiceListLen6444; choiceIndex6444++) {
    var choiceData6444 = choiceList6444[choiceIndex6444];
    output.append('<div class="checklist-item checklistWrap" data-index="', soy.$$escapeHtml(choiceIndex6444), '"><label class="el8label checklistLabel">', soy.$$escapeHtml(choiceData6444), '</label><div class="checklistField"><textarea class="w100" name="', soy.$$escapeHtml(opt_data.type), '-', soy.$$escapeHtml(choiceData6444), '" style="height:16px;"></textarea></div></div>');
  }
  output.append('<div class="checklist-buttons checklistButton"><ul class="el8ButtonContainer"><li class="el8ButtonItem"><a tabindex="-1" id="', soy.$$escapeHtml(opt_data.type), '-detail-clear-button" class="clear-trigger el8SmallTextLink">Clear fields</a></li>', (! opt_data.isVisitNoteTemplate) ? '<li class="el8ButtonItem"><a tabindex="-1" id="' + soy.$$escapeHtml(opt_data.type) + '-detail-save-new-button" class="save-new-trigger el8SmallTextLink">Save as Template</a></li>' : '', '</ul></div></fieldset>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.templateList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8Italic el8Gray el8AlignCenter padt10" data-testid="template-text-instruction">Click a template to add it to your note.</p><p class="el8AlignCenter"><a href="/settings/templates/" data-testid="template-edit-link" target="_blank" rel="noopener">add/edit/delete templates</a></p><ul class="ordersetContainer">');
  var templateList6466 = opt_data.templates;
  var templateListLen6466 = templateList6466.length;
  for (var templateIndex6466 = 0; templateIndex6466 < templateListLen6466; templateIndex6466++) {
    var templateData6466 = templateList6466[templateIndex6466];
    output.append('<li class="template-item item select-trigger " data-id="', soy.$$escapeHtml(templateData6466.id), '"><div class="ordersetTitle"><span class="el8BrandDark el8Bold">', soy.$$escapeHtml(templateData6466.name), '</span></div><div class="ordersetDetails">');
    var fieldList6472 = templateData6466.fields;
    var fieldListLen6472 = fieldList6472.length;
    for (var fieldIndex6472 = 0; fieldIndex6472 < fieldListLen6472; fieldIndex6472++) {
      var fieldData6472 = fieldList6472[fieldIndex6472];
      output.append('<p class="itemNoTextSaved"><span class="frame elt">', soy.$$escapeHtml(fieldData6472.name), ':</span> <span>', soy.$$escapeHtml(fieldData6472.value), '</span></p>');
    }
    output.append('</div></li>');
  }
  output.append('</ul>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.sectionTrigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="actionFieldButton"><a tabindex="-1" class="section-show-trigger el8FormLink" _section="', soy.$$escapeHtml(opt_data.name), '">', soy.$$escapeHtml(opt_data.label), '</a></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.previousVital = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.val) ? (opt_data.delta) ? soy.$$escapeHtml(opt_data.delta) + ' from ' + soy.$$escapeHtml(opt_data.val) + ((opt_data.units) ? ' ' + soy.$$escapeHtml(opt_data.units) : '') + ' (' + (soy.$$escapeHtml(opt_data.date)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.date)) : '') + ')' : soy.$$escapeHtml(opt_data.val) + ((opt_data.units) ? ' ' + soy.$$escapeHtml(opt_data.units) : '') + ' (' + (soy.$$escapeHtml(opt_data.date)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.date)) : '') + ')' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.templateformBillingExtraInfo = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="billing-header el8BillingBottom"><div class="w100"><div class="el8BillingHeaderItem mb5"><label class="el8label el8BillingHeaderLabel">Service Location</label><select class="w100 billing-service-location"></select></div><div class="el8BillingHeaderItem mb5"><label class="el8label el8BillingHeaderLabel">Place of Service (POS)</label><select class="w100 billing-place-of-service-code"></select><p class="padt3"><a target="_blank" rel="noopener" href="/settings/practice-locations/" class="el8StandardFontSize ml5">Edit Locations</a><a class="el8StandardFontSize ml10 refresh-service-locations">Refresh List</a></p></div><div class="el8BillingHeaderItem"><label class="el8label el8BillingHeaderLabel">Additional Billing Notes</label><div class="el8FieldSection el8EditorTextareaWrap"><textarea class="w100 el8BillingNotes" name="billingNotes"></textarea></div></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.serviceLocations = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var locList6517 = opt_data.serviceLocations;
  var locListLen6517 = locList6517.length;
  for (var locIndex6517 = 0; locIndex6517 < locListLen6517; locIndex6517++) {
    var locData6517 = locList6517[locIndex6517];
    output.append('<option value="', soy.$$escapeHtml(locData6517.id), '">', soy.$$escapeHtml(locData6517.name), '</option>');
  }
  output.append((! opt_data.kareoIntegrated) ? '<option value="">--</option>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.placesOfServiceOptions = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<option value="">--</option>');
  var posList6529 = opt_data.placesOfService;
  var posListLen6529 = posList6529.length;
  for (var posIndex6529 = 0; posIndex6529 < posListLen6529; posIndex6529++) {
    var posData6529 = posList6529[posIndex6529];
    output.append('<option value="', soy.$$escapeHtml(posData6529.code), '">', soy.$$escapeHtml(posData6529.code), ' - ', soy.$$escapeHtml(posData6529.name), '</option>');
  }
  if (!opt_sb) return output.toString();
};
